module.exports = __webpack_public_path__ + "img/39-config-perfis-lista.6fe8c000.png";